<div class="bg-white shadow-lg rounded-lg overflow-hidden transition-all duration-300 ease-in-out mx-2"
    [ngClass]="isOpen ? 'w-72 h-128' : 'w-72 h-12'">

    <!-- Header -->
    <div class="bg-blue-600 text-white flex justify-between items-center px-4 py-2 cursor-pointer"
        (click)="toggleChat()">
        <span class="font-semibold text-sm">
            <!-- {{ isOpen ? 'Chat with ' + 'name1' : 'name2' }} -->
            {{patientName}}
        </span>
        <span>
            <svg *ngIf="true" (click)="onChatClose()" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </span>
    </div>

    <!-- Body -->
    <div class="overflow-y-auto px-5 py-5 space-y-5" #scrollContainer
        [ngStyle]="{ 'max-height': isOpen ? '32rem' : '3rem' }">
        <!-- Chat Messages -->
        <div *ngFor="let msg of activeUser?.messages; trackBy: trackByIndex">
            <!-- Sent Message -->
            <div *ngIf="msg.type === 'sent'" class="flex items-end justify-end gap-3.5">
                <div class="flex flex-col gap-1.5 max-w-[75%]">
                    <div class="bg-primary text-light p-3 rounded-lg rounded-br-none shadow-sm">
                        <p class="text-sm font-medium">{{ msg?.message || '' }}</p>
                    </div>
                    <div class="flex items-center justify-end text-gray-600 text-xs relative">
                        <span class="me-6">{{ msg?.date | date: 'hh:mm a' }}</span>
                        <i class="ki-filled ki-double-check text-lg absolute text-gray-400"></i>
                    </div>
                </div>
                <img alt="" class="rounded-full size-9" [src]="'assets/media/app/final-icon-512.png'" />
            </div>

            <!-- Received Message -->
            <div *ngIf="msg.type !== 'sent'" class="flex items-end gap-3.5">
                <img alt="" class="rounded-full size-9" [src]="'assets/media/app/final-icon-512.png'" />
                <div class="flex flex-col gap-1.5 max-w-[75%]">
                    <div class="bg-gray-100 text-gray-700 p-3 rounded-lg rounded-bl-none shadow-sm">
                        <p class="text-sm font-medium">{{ msg?.message || '' }}</p>
                    </div>
                    <span class="text-xs font-medium text-gray-500">
                        {{ msg?.date | date: 'hh:mm a' }}
                    </span>
                </div>
            </div>

            <!-- Trial Alert -->
            <div *ngIf="!enableFeature" class="bg-yellow-100 text-yellow-700 p-2 rounded-md text-sm">
                <strong>Trial Mode:</strong> Your trial of Two-Way Texting will expire soon.
                <a (click)="sendFeatureRequest()" class="text-blue-500 underline cursor-pointer">Upgrade now</a> to keep
                using it!
            </div>
        </div>

        <!-- Loading or No Messages -->
        <div *ngIf="!activeUser?.messages.length">
            <app-spinner *ngIf="loading" [loading]="true"></app-spinner>
            <div *ngIf="!loading" class="bg-yellow-100 text-yellow-700 p-2 rounded-md text-sm">
                <strong>No messages:</strong> Send a message to start chat!
            </div>
        </div>
    </div>

    <!-- Send Box -->
    <div class="border-t border-gray-200 px-5 py-2.5 bg-white">
        <div class="relative">
            <img alt="" class="rounded-full size-[30px] absolute left-3 top-1/2 transform -translate-y-1/2"
                [src]="'assets/media/app/final-icon-512.png'" />
            <input [(ngModel)]="messageToSend"
                class="w-full pl-12 pr-28 py-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="Write a message..." type="text" (keyup.enter)="addNewMessage()" />
            <div class="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-2.5">
                <a class="btn btn-dark btn-sm" (click)="addNewMessage()">Send</a>
            </div>
        </div>
    </div>
</div>